import { useEffect, useState } from "react";

const navLinks = [
  { label: "首页", href: "#home" },
  { label: "热门推荐", href: "#hot" },
  { label: "分类浏览", href: "#category" },
  { label: "追更专区", href: "#follow" },
  { label: "关于我们", href: "#about" },
  { label: "常见问题", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b-2 border-background-200"
          : "bg-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-6" aria-label="主导航">
        <div className="flex h-16 md:h-20 items-center justify-between gap-4">
          {/* Logo */}
          <a
            href="#home"
            className="flex items-center gap-2 whitespace-nowrap group"
            aria-label="开心漫画网首页"
          >
            <span className="w-9 h-9 md:w-10 md:h-10 rounded-xl bg-primary-500 text-background-50 flex items-center justify-center shadow-comic group-hover:-rotate-6 transition-transform">
              <i className="ri-emotion-happy-line text-xl md:text-2xl" aria-hidden="true"></i>
            </span>
            <span className="font-heading text-xl md:text-2xl text-foreground-950 tracking-wide">
              开心漫画网
            </span>
          </a>

          {/* Desktop links */}
          <ul className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  className="px-3 py-2 text-sm text-foreground-800 hover:text-primary-700 hover:bg-primary-100/70 rounded-md transition whitespace-nowrap"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#follow"
              className="px-4 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-bold hover:bg-primary-600 transition whitespace-nowrap shadow-comic-sm"
            >
              开始追更
            </a>
          </div>

          {/* Mobile toggle */}
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-900 hover:bg-background-200/70"
            aria-label="展开菜单"
            aria-expanded={open}
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`} aria-hidden="true"></i>
          </button>
        </div>
      </nav>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden bg-background-50 border-t-2 border-background-200 px-4 py-4">
          <ul className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={() => setOpen(false)}
                  className="block px-3 py-2.5 rounded-md text-foreground-800 hover:bg-primary-100/70 hover:text-primary-700 transition"
                >
                  {link.label}
                </a>
              </li>
            ))}
            <li className="pt-2">
              <a
                href="#follow"
                onClick={() => setOpen(false)}
                className="block text-center px-4 py-2.5 rounded-full bg-primary-500 text-background-50 font-bold"
              >
                开始追更
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}